import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { globalVars } from "../../global/GlobalVars.js";

const LanguageSelector = observer((props) => {
  //========================================================================
  //
  const [language, setLanguage] = useState(globalVars.language);

  const handleChange = (event) => {
    const selectedLang = event.target.value;
    setLanguage(selectedLang);
    globalVars.setLanguage(selectedLang);
  };

  //========================================================================
  // Grafische Darstellung
  return (
    <div style={{ ...props.style }}>
      <select
        id="language-select"
        value={language}
        onChange={handleChange}
        style={{
          backgroundColor: props.style.backgroundColor,
          color: props.style.color,
          borderRadius: props.style.borderRadius,
          fontSize: props.style.fontSize,
          width: "100%",
          height: "100%",
          cursor: "pointer",
          appearance: "none",
          WebkitAppearance: "none",
          MozAppearance: "none",
          textAlign: "center",
        }}
      >
        {props.element.sprache1 && props.element.sprache1Text && (
          <option value={props.element.sprache1}>
            {props.element.sprache1Text}
          </option>
        )}

        {props.element.sprache2 && props.element.sprache2Text && (
          <option value={props.element.sprache2}>
            {props.element.sprache2Text}
          </option>
        )}

        {props.element.sprache3 && props.element.sprache3Text && (
          <option value={props.element.sprache3}>
            {props.element.sprache3Text}
          </option>
        )}
      </select>
    </div>
  );
});

export default LanguageSelector;
